import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_provider/${organization_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchProvider(
    organization_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_provider/${organization_id}/fetch_provider/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchSummary(
    organization_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_provider/${organization_id}/fetch_summary/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchHarvestsMonthly(
    organization_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_provider/${organization_id}/fetch_harvests_monthly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchHarvestsWeekly(
    organization_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_provider/${organization_id}/fetch_harvests_weekly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchTotalsMonthly(
    organization_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_provider/${organization_id}/fetch_totals_monthly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchTotalsWeekly(
    organization_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_provider/${organization_id}/fetch_totals_weekly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchCropSizes(
    organization_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_provider/${organization_id}/fetch_crop_sizes/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchExportedBatchesTotal(
    organization_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_provider/${organization_id}/fetch_exported_batches_total/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchExportedBatches(
    organization_id,
    agro_exporter_process_id,
    provider_type,
    provider_id,
    current_page,
    rows_per_page
  ) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_provider/${organization_id}/fetch_exported_batches/${agro_exporter_process_id}/${provider_type}/${provider_id}/${current_page}/${rows_per_page}`
    );
  },

  fetchHarvestedBatch(
    organization_id,
    agro_exporter_process_id,
    harvested_batch_id
  ) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_provider/${organization_id}/fetch_harvested_batch/${agro_exporter_process_id}/${harvested_batch_id}`
    );
  }
};
